import { render, staticRenderFns } from "./CustTablesTable.vue?vue&type=template&id=c33ad242&"
import script from "./CustTablesTable.vue?vue&type=script&lang=js&"
export * from "./CustTablesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports